import React, { useContext, useMemo, useRef, useEffect } from 'react';
import { noop } from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { TextAssetCollectionWithRecommendations } from './text-asset-collection-with-recommendations';
import { getTextAssetCollectionConfig } from './pmax-text-asset-collection-config';
import { getTextAssetCollectionConfigByFeature } from './utils';

export const HeadlineAssetCollection = React.memo((props) => {
  const {
    featureName,
    enableCopilotRecommendations,
    enableCustomizer,
    isOptional,
    showDeleteButton,
    renderInlineCopilot,
    setAddNewShortHeadlinesCallback,
    onFocusTextAsset,
    onDeleteTextAsset,
    onApplyRecommendation,
    isAudienceAd,
  } = props;
  const i18n = useContext(I18nContext);

  const textAssetCollectionConfig = useMemo(() => getTextAssetCollectionConfigByFeature({ featureName }), [featureName]);

  const headlineConfig = useMemo(() => getTextAssetCollectionConfig('headlines', i18n, textAssetCollectionConfig), [i18n, textAssetCollectionConfig]);
  const addNewHeadlinesCallback = useRef(noop);

  useEffect(() => {
    if (setAddNewShortHeadlinesCallback) {
      setAddNewShortHeadlinesCallback(() => (recommendations, replaceExistingAssets) => {
        addNewHeadlinesCallback.current(recommendations, replaceExistingAssets);
      });
    }
  }, [setAddNewShortHeadlinesCallback]);

  return (
    <div className="headline-asset-collection">
      <TextAssetCollectionWithRecommendations
        {...headlineConfig}
        isOptional={isOptional}
        showDeleteButton={showDeleteButton}
        onDeleteTextAsset={onDeleteTextAsset}
        onApplyRecommendation={onApplyRecommendation}
        renderInlineCopilot={renderInlineCopilot}
        i18n={i18n}
        onFocusTextAsset={onFocusTextAsset}
        withInlineRecommendations
        setAddTextAssetCallback={(callback) => { addNewHeadlinesCallback.current = callback; }}
        enableCopilotRecommendations={enableCopilotRecommendations}
        enableCustomizer={enableCustomizer}
        withDeleteIconDisabled
        isAudienceAd={isAudienceAd}
      />
    </div>);
});

HeadlineAssetCollection.propTypes = {
  isOptional: PropTypes.bool,
  showDeleteButton: PropTypes.bool,
  onDeleteTextAsset: PropTypes.func,
  onApplyRecommendation: PropTypes.func,
  renderInlineCopilot: PropTypes.func,
  setAddNewShortHeadlinesCallback: PropTypes.func,
  onFocusTextAsset: PropTypes.func,
  featureName: PropTypes.string,
  enableCopilotRecommendations: PropTypes.bool,
  enableCustomizer: PropTypes.bool,
  isAudienceAd: PropTypes.bool,
};

HeadlineAssetCollection.defaultProps = {
  isOptional: false,
  showDeleteButton: false,
  onDeleteTextAsset: noop,
  onApplyRecommendation: noop,
  renderInlineCopilot: null,
  setAddNewShortHeadlinesCallback: null,
  onFocusTextAsset: noop,
  featureName: undefined,
  enableCopilotRecommendations: true,
  enableCustomizer: false,
  isAudienceAd: false,
};
